import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import ItemSelector from "./components/ItemSelector";
import { extractBusinessNames } from "./utils/availabilityHelpers";
import AvailabilitiesCalendar from "./components/Calendar";
import {
  AvailabilitiesProvider,
  useAvailabilities,
} from "./AvailabilitiesProvider";
import AvailabilityDetailModal from "./components/AvailabilityDetailModal";
import ItemDetailModal from "./components/ItemDetailModal";
import BulkDeleteButton from "./components/BulkDeleteButton";
import {
  DeleteConfirmDialog,
  DeleteSuccessDialog,
} from "./components/DeleteConfirmDialog";

function AllAvailabilitiesContent() {
  const {
    currentMonth,
    navigateMonth,
    items,
    selectedAvailabilities,
    selectionCounts,
    isBulkDeleting,
    deletePopupOpen,
    setDeletePopupOpen,
    successPopupOpen,
    successfulDeletes,
    handleBulkDelete,
    handleDeleteButtonClick,
    handleSuccessDialogClose,
  } = useAvailabilities();

  const itemNames = extractBusinessNames(items);

  return (
    <Box sx={{ p: { xs: "16px", md: "32px" }, minHeight: "100vh" }}>
      <Box mb="14px">
        <Typography
          variant="h5"
          mb="34px"
          sx={{ fontSize: { xs: "32px", md: "44px" }, fontWeight: 700 }}
        >
          My Calendar
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <ChevronLeft
            sx={{ cursor: "pointer", fontSize: "40px" }}
            onClick={() => navigateMonth("prev")}
          />
          <Typography
            variant="h6"
            sx={{
              minWidth: "160px",
              textAlign: "center",
              fontSize: { xs: "24px", md: "34px" },
              fontWeight: 700,
            }}
          >
            {currentMonth.format("MMMM YYYY")}
          </Typography>
          <ChevronRight
            sx={{ cursor: "pointer", fontSize: "40px" }}
            onClick={() => navigateMonth("next")}
          />
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
          <ItemSelector itemNames={itemNames} isExistingBookingLink={false} />
        </Box>
        <BulkDeleteButton
          selectedCount={selectedAvailabilities.length}
          selectionCounts={selectionCounts}
          isBulkDeleting={isBulkDeleting}
          isExistingBookingLink={false}
          onDeleteClick={handleDeleteButtonClick}
        />
      </Box>
      <AvailabilitiesCalendar selectedDate={currentMonth} />
      <AvailabilityDetailModal />
      <ItemDetailModal />

      <DeleteConfirmDialog
        open={deletePopupOpen}
        onClose={() => setDeletePopupOpen(false)}
        onConfirm={handleBulkDelete}
        selectedCount={selectedAvailabilities.length}
        selectionCounts={selectionCounts}
        isDeleting={isBulkDeleting}
      />

      <DeleteSuccessDialog
        open={successPopupOpen}
        onClose={handleSuccessDialogClose}
        deletedCount={successfulDeletes}
      />
    </Box>
  );
}

export default function AllAvailabilities() {
  return (
    <AvailabilitiesProvider>
      <AllAvailabilitiesContent />
    </AvailabilitiesProvider>
  );
}
